import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Webhook } from 'src/app/models/webhook';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { debounceTime, distinctUntilChanged, switchMap, catchError, tap } from 'rxjs/operators';
import { Subscription, EMPTY, Observable } from 'rxjs';
import { SmoochService } from 'src/app/services/smooch.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-webhook-editor',
  templateUrl: './webhook-editor.component.html',
  styleUrls: ['./webhook-editor.component.scss']
})
export class WebhookEditorComponent implements OnInit, OnDestroy {

  private _subscription: Subscription;

  @Input() webhook: Webhook;

  webhookForm: FormGroup;

  constructor(
    private _formBuilder: FormBuilder,
    private _smoochService: SmoochService,
    private _snackBar: MatSnackBar
  ) { }

  ngOnInit() {
    this.webhookForm = this._formBuilder.group({
      target: [this.webhook.target, Validators.required]
    });

    this._subscription = this.webhookForm.valueChanges.pipe(
      debounceTime(1000),
      distinctUntilChanged(),
      switchMap(form => {
        let clone: Webhook = JSON.parse(JSON.stringify(this.webhook));
        clone.target = form.target;

        if (!this.webhookForm.valid) {
          return EMPTY;
        }

        if (clone._id) {
          return this.updateWebhook(clone);
        } else {
          return this.createWebhook(clone);
        }
      })
    ).subscribe();
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }

  copied(): void {
    this._snackBar.open(`Copied to clipboard.`);
  }

  private updateWebhook(webhook: Webhook): Observable<Webhook> {
    return this._smoochService.updateWebhook(webhook).pipe(
      tap(() => {
        this._snackBar.open(`Updated webhook target URL to ${webhook.target}`);
      }),
      catchError((error) => {
        this._snackBar.open(`Failed to update webhook target URL (${webhook.target}).  ${error.error.description}`);
        return EMPTY;
      })
    );
  }

  private createWebhook(webhook: Webhook): Observable<Webhook> {
    return this._smoochService.createWebhook(webhook.target).pipe(
      tap(() => {
        this.webhookForm.patchValue({ target: "" }, { emitEvent: false });
        this._snackBar.open(`Created webhook target URL to ${webhook.target}`);
      }),
      catchError((error) => {
        this._snackBar.open(`Failed to create webhook target URL (${webhook.target}).  ${error.error.description}`);
        return EMPTY;
      })
    );
  }
}
